/* Propuesta -  registro de propuesta de cambio */
/* Contenido - registro o visualización de la propuesta */

//*react- recursos
    import { useState, useEffect } from "react";
    import { BsEnvelope, BsCalendarEvent, BsFillCheckSquareFill } from "react-icons/bs"; 
    import swal2 from "sweetalert2"; //npm install --save sweetalert2

//*componentes-utiles
    import CargandoSpin from "../../../../componentes/CargandoSpin";

//*clases 
    import { Col, Row } from "react-bootstrap";
    import ReactTooltip from "react-tooltip";
    import '../../../../css/mdi.css'; 

//*archivos (imagenes y elementos necesarios para la rutina)

//*api's (servicios y store)
    import proposalsServicio from "../../../../api/recursos/proposals/proposals.servicio"; 
    import proposalsStore from "../../../../api/recursos/proposals/proposals.store"; 

    import notificationsServicio from "../../../../api/recursos/notifications/notifications.servicio"; 
    import notificationsStore from "../../../../api/recursos/notifications/notifications.store"; 

//*store's

//*datos
    import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json";
    import articulos from "../../../../datos/json/guidelines.json";
    import { boolean, number } from "yup";

//*interfaces
    interface propsPropuestaContenido {
        tokenStore: any;
        propuestaNva: any;
        idPropuesta: any;
        catOrigenesStore: any;
        catProcesosStore: any;
        botonCierraPropuesta:any
        recargaPropuesta: any;
        recargaPropuestaNva: any;
        recargaPaginaSSC: any;
        recargaPaginaSSC_Not: any;
    }

//*componente
    export default function PropuestaContenido(props: propsPropuestaContenido) {  
    //*api store
        const { propuestaNvaStore,
                guardaGetDetailbyUserStore, propuestaDetallesStore,
                guardaInsertbyUserStore, 
                guardaUpdatebyUserStore, 
                guardaDeletebyUserStore, 
                guardaSendbyUser, 
                cambiaPropuestasStore,
                eliminaPropuestasStore,
                generaObjErrorProposalsStore} =  
            proposalsStore((state:any) =>( { 
                propuestaNvaStore: state.propuestaNvaStore,
                guardaGetDetailbyUserStore: state.guardaGetDetailbyUserStore,
                propuestaDetallesStore: state.propuestaDetallesStore,
                guardaInsertbyUserStore: state.guardaInsertbyUserStore,
                guardaUpdatebyUserStore: state.guardaUpdatebyUserStore,
                guardaDeletebyUserStore: state.guardaDeletebyUserStore,
                guardaSendbyUser: state.guardaSendbyUser,
                cambiaPropuestasStore: state.cambiaPropuestasStore,
                eliminaPropuestasStore: state.eliminaPropuestasStore,
                generaObjErrorProposalsStore: state.generaObjErrorProposalsStore
        }));

        const { guardaSendEmailStore, sendEmailStore,
                generaObjErrorNotificationsStore } =  
            notificationsStore((state:any) =>( { 
                guardaSendEmailStore: state.guardaSendEmailStore,
                sendEmailStore: state.sendEmailStore,
                generaObjErrorNotificationsStore: state.generaObjErrorNotificationsStore
        }));

    //*store's
    //*datos

    //*constantes y variables
        let etiGlobal = etiquetasSSC.Global.botones;
        let eti = etiquetasSSC.Propuesta;
        let x1,x2,x3,x4,x5,x6 = '';
        let noPasa = '';
        let notifica = ''
        let cuentaCatO=0;
        let cuentaCatP=0;
        let IdNuevo = 0;
        let catOrigenesFrontCopia:any=[];
        let catProcesosFrontCopia:any=[];
        
    //*useState
        const [swRecarga,setSwRecarga] = useState(false);
        const [swRecargaPropuestaContenido,setSwRecargaPropuestaContenido] = useState(false);
        const [swRecargaPropuestaDetalles, setSwRecargaPropuestaDetalles] = useState(false); 
        const [cargandoSpin,setCargandoSpin] = useState(false);

        const [propuestaNva, setPropuestaNva] = useState(props.propuestaNva); 
        const [propuestaNvaFront, setPropuestaNvaFront] = useState(props.propuestaNva); 
        
        const [idPropuestaFront, setIdPropuestaFront] = useState(props.idPropuesta); //no me deje actualizar por useState, tuve que generar un let directo
       
        const [propuestaDetallesFront, setPropuestaDetallesFront] = useState(propuestaDetallesStore); 
        const [desCambioFront, setDesCambioFront] = useState(propuestaDetallesStore.description);
        const [catOrigenesFront, setCatOrigenesFront] = useState(propuestaDetallesStore.miCatOrigenes);
        const [catProcesosFront, setCatProcesosFront] = useState(propuestaDetallesStore.miCatProcesos); 
        const [swBotonGuardar, setSwBotonGuardar] = useState(propuestaDetallesStore.btnGuardar); 
        const [swBotonEnviar, setSwBotonEnviar] = useState(propuestaDetallesStore.btnEnviar); 
        const [swBotonEliminar, setSwBotonEliminar] = useState(propuestaDetallesStore.btnEliminar); 
        const [isChecked, setIsChecked] = useState(false);
    
    //*useEffect

        useEffect(() => { //cuando montamos
            console.log('Propuesta.Contenido- monto')
            console.log('........props.propuestaNva', props.propuestaNva);
            limpiaPlantilla(); //limpiamos plantilla
             //limpio catálogos
             props.catOrigenesStore.map((o:any) => {
                o.activo=false;
                o.disabled=false;
                o.specification='';
            });
            props.catProcesosStore.map((o:any) => {
                o.activo=false;
                o.disabled=false;
            });
        },[]);

        useEffect(() => { //Carga detalles de la propuesta - llama API - Proposals/GetDetailbyUser/es/id
           if (propuestaNva==false) { //propuesta existente
                setIdPropuestaFront(props.idPropuesta);
                setCargandoSpin(true);
                proposalsServicio.cargaGetDetailbyUser(props.tokenStore, idPropuestaFront)
                .then((response:any) => {
                    if (response.status==200) {  //confirma que no hay error
                        guardaGetDetailbyUserStore(response.data, props.idPropuesta, props.catOrigenesStore, props.catProcesosStore,'Propuesta').then( function(datos:any) { 
                            setPropuestaDetallesFront(datos);
                            setDesCambioFront(datos.description);
                            setCatOrigenesFront(datos.miCatOrigenes);
                            setCatProcesosFront(datos.miCatProcesos);
                            setSwBotonGuardar(datos.btnGuardar);
                            setSwBotonEnviar(datos.btnEnviar);
                            setSwBotonEliminar(datos.btnEliminar);

                            setSwRecarga(!swRecarga);
                        })
                    } 
                    setCargandoSpin(false);
                })
                .catch((ex) => {
                    console.log ("--catch - ex (cargaGetDetailbyUser): ", ex.response.status);
                    if (ex.response.status==404) //no es error solo no tiene información
                        console.log('nota: no es error solo no tiene información')
                    else
                        generaObjErrorProposalsStore(ex.response, true, '', '', 'Propuesta-Proposals/GetDetailbyUser','P')
                    setCargandoSpin(false);
                    recargaPaginaSSC();
                })
           }
           else { //propuesta nueva - asigno lo correspondiente
                //setIdPropuestaFront(0);
                catOrigenesFrontCopia= JSON.parse(JSON.stringify(props.catOrigenesStore));
                catProcesosFrontCopia= JSON.parse(JSON.stringify(props.catProcesosStore));
                setPropuestaDetallesFront(propuestaNvaStore);
                setDesCambioFront('');
                setCatOrigenesFront(catOrigenesFrontCopia);
                setCatProcesosFront(catProcesosFrontCopia);
                setSwBotonGuardar(propuestaDetallesFront.btnGuardar);
                setSwBotonEnviar(propuestaDetallesFront.btnEnviar);
                setSwBotonEliminar(propuestaDetallesFront.btnEliminar); 
                setSwRecarga(!swRecarga);
            }
        },[swRecargaPropuestaDetalles]);
       
        useEffect(()=> {  //usado para renderizar
            console.log('Propuesta.Contenido - renderizando .........................');
                         
            if (props.propuestaNva) { setSwBotonEliminar(false) }
            else { setSwBotonEliminar(true) }
            console.log('---swBotonEliminar:', swBotonEliminar);

            setSwRecargaPropuestaContenido(!swRecargaPropuestaContenido);
            /* console.log('---idPropuesta:', props.idPropuesta);
            console.log('---propuestaDetallesFront:', propuestaDetallesFront);
            console.log('---desCambioFront:', desCambioFront);
            console.log('---catOrigenesFront:', catOrigenesFront);
            console.log('---catProcesosFront:', catProcesosFront);
            console.log('---swBotonGuardar:', swBotonGuardar);
            console.log('---swBotonEnviar:', swBotonEnviar);
            console.log('---swBotonEliminar:', swBotonEliminar); */
        },[swRecarga]);

    //*funciones

        const recargaPaginaSSC = () => { props.recargaPaginaSSC() } //ejecuta la función que esta en Contenido que llama a la renderización de PaginaSSC
        const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta en Contenido que llama de PaginaSSC recargar el api de notificaciones para la campana
        const recargaPropuesta = () => {  props.recargaPropuesta() }
        const recargaPropuestaNva = () => {  props.recargaPropuestaNva() }

        const recargaPropuestaContenido = () => {
           setSwRecarga(!swRecarga); // con esto ejecuto un useEffect, lo uso para renderizar el front 
        }

        const botonGuardar = () => {
            noPasa = "";
            notifica='';

            //alert('boton guardar');
            //console.log('propuestaFront antes de guardar:::', propuestaDetallesFront)
            //primer filtro (resultado en nopaso) obliga la descripción del cambio; si activa un elemento de origenes tiene que darle su descripción
            botonGuardarValidaPlantilla(1)
            if ( noPasa != '' ) { 
                swal2
                .fire({
                    title: eti.mensajes[4].text, //El registro de la propuesta de cambio NO ha sido guardado
                    icon: 'error',
                    showCancelButton: true,
                    showConfirmButton:false,
                    imageUrl: 'src/imagenes/checkT.png',
                    cancelButtonText: "Cerrar",
                    cancelButtonColor: '#d33',
                    width: "70%",
                    html: "<div>" + noPasa + "</div>",
                })
            }
            else { //no tiene errores la plantilla puede guardar
                botonGuardarValidaPlantilla(2)  //segundo filtro (resultado en notifica), si le permite guardar pero le notifica sus pendientes 
                botonGuardarEnAPI();  //guarda plantilla citando al api
            }
        }

        const botonGuardarValidaPlantilla = (filtro:any) => {
            //alert('validaPlantilla - filtro ' + filtro);
            if (filtro==1) { 
                //noPasa = ''; 
                //revisamos que la descripción no vaya vacía
                    if ( desCambioFront== '') { noPasa =  eti.mensajesErrores[4].text + '<br />' }

                //al menos un elemento de origen de cambio con su descripción    
                    cuentaCatO=0;
                    let pasoO = '';
                
                    catOrigenesFront.map((o:any) => {
                        if (o.activo)
                            cuentaCatO = cuentaCatO + 1;
                        if (o.activo && o.specification=='') {
                            if (pasoO=='')
                                pasoO =  eti.mensajesErrores[5].text  + '<br/>' + '&nbsp;&nbsp;&nbsp;<b><i> '+ o.name+ ' </b></i> <br/>';
                            else
                                pasoO = pasoO + '&nbsp;&nbsp;&nbsp;<b><i> '+ o.name+ ' </b></i> <br/>';
                        }    
                    });
                    //if (cuentaCatO==0) { noPasa = noPasa + eti.mensajesErrores[6].text + '<br/>' } 
                    if (pasoO !='') { noPasa = noPasa + '<br />' +  pasoO };
        
                if (noPasa != '') { noPasa = '<b>Importante:</b><br/><br/>' + noPasa }
            }
            if (filtro==2) {
                notifica = '';
                if (cuentaCatO==0) { //lo contené en filtro 1
                    notifica = eti.mensajesErrores[1].text + '<br/><br/>';
                    notifica = notifica + '&nbsp;&nbsp; '+ eti.mensajesErrores[6].text + '<br/><br/>';
                } 
                cuentaCatP=0;
                catProcesosFront.map((p:any) => {
                    if (p.activo) { cuentaCatP = cuentaCatP + 1}
                });
                if (cuentaCatP==0) {
                    if (notifica == '') { notifica = eti.mensajesErrores[1].text + '<br/><br/>' };
                    notifica = notifica + '&nbsp;&nbsp; '+  eti.mensajesErrores[7].text + '<br/><br/>';
                }
                if (notifica != '') {
                    notifica = notifica + eti.mensajesErrores[2].text + '<br/><br/>';
                    notifica = notifica + eti.mensajesErrores[3].text + '<br/><br/>';
                }
            }
        }

        const botonGuardarEnAPI = () => {
            //alert('botonGuardarEnAPI');
            let bodyAPI= { id:number, description:'', origin:[],  processxfrequency: [] };
                bodyAPI.id = props.idPropuesta;
                bodyAPI.description = desCambioFront;
            let pasoCatO: any = [];
            let bodyOrigin= {id:0, name: '', specification: ''};
            let pasoCatP: any = [];

            //copia información de plantilla a objeto del body para api  
            if (cuentaCatO > 0) {  //cuentaCatO lo generé en botonGuardarValidaPlantilla filtro 1 
                catOrigenesFront.map((o:any) => {
                    bodyOrigin= {id:0, name: '', specification: ''};
                    if (o.activo){
                        bodyOrigin.id= o.id; 
                        bodyOrigin.name = o.name;
                        bodyOrigin.specification= o.specification;
                        //bodyAPI.origin.push(bodyOrigin);
                        pasoCatO.push(bodyOrigin);
                    }
                });
                bodyAPI.origin = pasoCatO;
            };

            let pasoProcessxfrequency:any = [];
            if (cuentaCatP > 0) {  //cuentaCatP lo generé en botonGuardarValidaPlantilla filtro 2 
                catProcesosFront.map((p:any) => {
                    if (p.activo){
                        pasoCatP.push(p.id);
                        pasoProcessxfrequency.push(p);
                    }
                });
                bodyAPI.processxfrequency = pasoCatP;
            }

            //console.clear();
            //console.log('*body para insertar y/o regrabar...', bodyAPI );
            //console.log('IdNuevo...', IdNuevo );
            //console.log('props.idPropuesta...', props.idPropuesta );

            //por donde nos vamos insertar (nuevo) o regrabar (existente)
            if (propuestaNvaFront) { //insertamos propuesta llamando al api: Proposals/InsertbyUser
                //alert('insert');
                setCargandoSpin(true);
                proposalsServicio.cargaInsertbyUser(props.tokenStore, bodyAPI)
                    .then((response:any) => {
                        //console.log('response.................',response)
                        if (response.status==200) {  //revisa si hay error
                            guardaInsertbyUserStore(response.data, bodyAPI, pasoProcessxfrequency, catOrigenesFront, catProcesosFront)
                            .then( function(insertbyUserFront:any) { 
                                console.log('...............insertbyUserFront: ', insertbyUserFront ); //response.data
                                //console.log('...............insertbyUserFront.id: ', insertbyUserFront.id );
                                setPropuestaNvaFront(false);
                                //idPropuestaFront = insertbyUserFront.id;
                                IdNuevo = insertbyUserFront.id; 
                                setIdPropuestaFront(IdNuevo);
                                setSwBotonEliminar(true);
                                console.log('------------::::::::::::::::::::::IdNuevo: ',IdNuevo );
                              
                                recargaPropuestaNva();
                                recargaPropuesta();
                                recargaPropuestaContenido();
                                abreNotifica();
                            });     
                        }    
                        setCargandoSpin(false);
                    })
                    .catch((ex) => {
                        console.log ("--catch - ex (cargaInsertbyUser): ", ex.response.status);
                        generaObjErrorProposalsStore(ex.response, true, '', '', 'PropuestaContenido-Proposals/InsertbyUser','P');
                        setCargandoSpin(false);
                        recargaPaginaSSC();
                    })
            } 
            else { //guardamos propuesta existente (si es nueva ya guardo una vez) Proposals/UpdatebyUser
                //alert('update');
                setCargandoSpin(true);
                proposalsServicio.cargaUpdatebyUser(props.tokenStore, bodyAPI)
                    .then((response:any) => {
                        if (response.status==200){  //confirma que no hubo error
                            guardaUpdatebyUserStore(response.data, bodyAPI, catOrigenesFront, catProcesosFront).then( function(updatebyUserFront:any) { //mando bodyAPI para actualizar el encabezado de la propuesta
                                console.log('...............updatebyUserFront: ', updatebyUserFront ); //response.data
                                //console.log('...............updatebyUserFront.id: ', updatebyUserFront.id );
                                //console.log('updatebyUserFront: ', updatebyUserFront );            
                                //if (updatebyUserFront.ret==1) { //confirmo respuesta de api
                                    setSwBotonGuardar(false); //ya guardo lo inhabilito hasta que hago un cambio o envie
                                    recargaPropuestaContenido();
                                    recargaPropuesta();  //**renderizo desde la página propuesta
                                    abreNotifica();
                                //}
                            });         
                        } 
                        setCargandoSpin(false);       
                    })
                    .catch((ex) => {
                        console.log ("--catch - ex (cargaUpdatebyUser): ", ex.response.status);
                        generaObjErrorProposalsStore(ex.response, true, '', '', 'PropuestaContenido-Proposals/UpdatebyUser','P');
                        setCargandoSpin(false);
                        recargaPaginaSSC();
                    })
            }
            //abreNotifica();
        }

        const abreNotifica = () => {
            //alert('abreNotifica');
            console.log('a------------::::::::::::::::::::::IdNuevo: ',IdNuevo );
            console.log('a------------::::::::::::::::::::::idPropuestaFront: ', idPropuestaFront );
            //notifica al usuario los pendientes
            if ( notifica=='' ) {  //no hay pendinte, se guardo y pregunta si quiere enviar
                swal2.fire({
                    title: eti.mensajes[0].text, // El registro de la propuesta de cambio fue guardada
                    icon: 'success',
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i> Enviar',
                    cancelButtonText: 'Cerrar',
                    //denyButtonText:  "Cerrar",
                    width: "70%",
                    html: "<div>" + eti.mensajes[1].text + "</div>",
                }).then((result) => {
                    if (result.isConfirmed) {  botonEnviar() }
                })
                //console.log('paso por aquí')

                setSwBotonGuardar(false); 
                setSwBotonEnviar(true); // ya no tiene errores ya puede enviar
            }  
            else {  //pendientes en plantilla
                swal2.fire({
                        title: eti.mensajes[0].text, // El registro de la propuesta de cambio fue guardado.. Completar... Guardar ... Enviar
                        icon: 'warning',
                        //showCancelButton: true,
                        confirmButtonText: "Cerrar",
                        confirmButtonColor: '#3085d6',
                        width: "70%",
                        html: "<div> <b>Importante: </b><br/><br/>" + notifica + "</div>",
                    })
            }
            recargaPropuesta(); 
        }

        const botonEnviar = () => {
            //alert('botonEnviar');
            console.log('b------------::::::::::::::::::::::IdNuevo: ',IdNuevo );
            console.log('b------------::::::::::::::::::::::idPropuestaFront: ', idPropuestaFront );
            console.log('b------------::::::::::::::::::::::propuestaNvaFront: ', propuestaNvaFront );
            //alert('en body antes de enviar: ' + idPropuestaFront + '-' + IdNuevo); 
            let bodyAPI= { id:0, send:false};
            bodyAPI.id = (propuestaNvaFront==false) ? idPropuestaFront : IdNuevo;
            bodyAPI.send = true;
            console.log('b------------::::::::::::::::::::::bodyAPI: ', bodyAPI );
            if (bodyAPI.id != 0) {
                setCargandoSpin(true);
                //enviamos la propuesta llamando al api: Proposals/SendbyUser
                proposalsServicio.cargaSendbyUser(props.tokenStore, bodyAPI)
                .then((response:any) => {
                    if (response.status==200) {  //confirma que no hubo error
                        guardaSendbyUser(response.data).then( function(sendbyUserFront:any) {
                            console.log('.....sendbyUserFront', sendbyUserFront);
                            cambiaPropuestasStore(props.idPropuesta, false, null, 'botonEnviar');
                            setCargandoSpin(false);
                            swal2.fire({
                                title: eti.mensajes[2].text, // El registro de la propuesta de cambio fue guardada
                                icon: 'success',
                                confirmButtonText: "Cerrar",
                                confirmButtonColor: '#3085d6',
                                width: "70%",
                            })
                            props.recargaPropuestaNva();
                            recargaPropuesta(); 
                            setSwBotonGuardar(null);
                            setSwBotonEnviar(null);
                            setSwRecarga(!swRecarga);
                            let bodyAPINot:any= { idproposal:number };
                                bodyAPINot.idproposal = bodyAPI.id; //props.idPropuesta;

                            setCargandoSpin(true);
                            notificationsServicio.cargaSendEmail(props.tokenStore, bodyAPINot)
                                .then((response:any) => {
                                    if (response.status==200){  //confirma que no hubo error
                                        guardaSendEmailStore(response.data).then( function(sendEmailFront:any) { 
                                            console.log(':::::sendEmailFront',sendEmailFront)
                                            //recargaPropuesta();  //**renderizo desde la página propuesta
                                        }); 
                                    }
                                    setCargandoSpin(false);
                                   
                                })
                                .catch((ex) => {
                                    console.log ("--catch - ex (cargaUpdatebyUser): ", ex.response.status);
                                    generaObjErrorNotificationsStore(ex.response, true, '', '', 'Propuesta.Contenido-Notificatios/SendEmail','P');
                                    setCargandoSpin(false);
                                    recargaPaginaSSC();
                                })
                            recargaPropuesta();
                            recargaPaginaSSC_Not();
                        })
                    }
                    
                })
                .catch((ex) => {
                    console.log ("--catch - ex (cargaUpdatebyUser): ", ex.response.status);
                    generaObjErrorProposalsStore(ex.response, true, '', '', 'Propuesta.Contenido-Proposals/SendbyUser','P');
                    setCargandoSpin(false);
                    recargaPaginaSSC();
                })
            }
            else { 
                alert('es id 0, no puedo enviar') 
            }
        }

        const botonEliminar = () => {
            //alert('boton Eliminar');
            setCargandoSpin(true);
            //eliminamos la propuesta llamando al api: Proposals/DeletebyUser
            proposalsServicio.cargaDeletebyUser(props.tokenStore, props.idPropuesta)
            .then((response:any) => {
                //console.log('response.................', response)
                if (response.status==200){  //confirma acceso del api
                    guardaDeletebyUserStore(response.data).then( function(deletebyUserFront:any) {//va a store a guardar información
                        if (deletebyUserFront.ret==1) { //confirmo respuesta de api
                            eliminaPropuestasStore(props.idPropuesta);
                            recargaPropuesta();  //**renderizo desde la página propuesta
                            setCargandoSpin(false);
                            swal2.fire({
                                icon: 'success',
                                //showCancelButton: true,
                                confirmButtonText: "Cerrar",
                                confirmButtonColor: '#3085d6',
                                width: "70%",
                                title: eti.mensajes[3].text,
                                //html: "<div>" +  "</div>",
                            })
                            //**ojo inactivo la propuesta, ver si lo hago con el api gral
                        } 
                    })
                }
                setCargandoSpin(false);
            })
            .catch((ex) => {
                console.log ("--catch - ex (cargaUpdatebyUser): ", ex.response.status);
                generaObjErrorProposalsStore(ex.response, true, '', '', 'PropuestaContenido-Proposals/DeletebyUser','P')
                setCargandoSpin(false);
                recargaPaginaSSC();
            })
        }

        const botonCerrar = () => {
            if (swBotonGuardar) { //si esta activo el botón guardar hay cambios...
                swal2.fire({
                    title: eti.mensajes[4].text, // El registro de la propuesta de cambio NO ha sido guardado - ¿Desea salir sin guardar?
                    text: "",
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    width: '50%',
                    html: "<div class='h4'>" + eti.mensajes[5].text + "</div>",
                }).then((result) => {
                    if (result.isConfirmed) {  props.botonCierraPropuesta(props.idPropuesta) }
                })
            }
            else {  //cerramos 
                props.botonCierraPropuesta(props.idPropuesta)
            } 
            limpiaPlantilla();
        }

        const limpiaPlantilla = () => {
            setPropuestaDetallesFront(propuestaNvaStore);
            setDesCambioFront('');
           
            setCatOrigenesFront(catOrigenesFrontCopia);
            setCatProcesosFront(catProcesosFrontCopia);

            setSwBotonGuardar(false);
            setSwBotonEnviar(false);
            setSwBotonEliminar(null); 
            recargaPropuestaContenido();
        }
        
        const armaDesCambio = (e:any) => {
            //console.log('e.target.value::',e.target.value);
            setDesCambioFront(e.target.value);
            setIsChecked(!isChecked); //lo uso de puente para que recargue el front y se lleve el dato
            setSwBotonGuardar(true); //habilitar boton guardar en front
            setSwBotonEnviar(false); // hasta que grabe envia
            //console.log('desCambioFront::',desCambioFront);
        };
    
        const armaCatOrigenes = (e:any) => {
            // console.log('e.target.id::', e.target.id);
            //let miCheckId = "0123456789_123_5"; 
            let miCheckId = e.target.id; 
            //console.log('miCheckId.....', miCheckId)
            let posP = miCheckId.indexOf('_');
            //console.log('**posP.....', posP)
            let paso = miCheckId.substr( posP+1, miCheckId.length-posP );
            //console.log('**paso.....', paso)
            //console.log('**paso.length.....', paso.length)
            let posC = paso.indexOf('_');
            //console.log('**posC.....', posC)
            let propuestaId = paso.substr( 0, posC );
            let catalogoId = paso.substr(posC+1, paso.length-posC-1 );
            //console.log('**propuestaId.....', propuestaId)
            //console.log('**catalogoId.....', catalogoId)
            
            catOrigenesFront.map((o:any) => {
                if (o.id == catalogoId)
                    o.activo = !o.activo
            });  
            setIsChecked(!isChecked); // lo uso para que restarure la página y tome mis cambios
            setSwBotonGuardar(true);
            setSwBotonEnviar(false); // hasta que grabe envia
            //console.log('.......catOrigenesFront...',catOrigenesFront)
        }

        const armaCatOrigenesEspecifica = (e:any) => {
        //console.log('e.target.id::', e.target.id);
        //console.log('e.target.value::', e.target.value);
        // catO-Especifica_NEW_1
        // 012345678901234_678_9
        let miCheckId = e.target.id; 
        //console.log('miCheckId.....', miCheckId)
        let posP = miCheckId.indexOf('_');
        //console.log('**posP.....', posP)
        let paso = miCheckId.substr( posP+1, miCheckId.length-posP );
        //console.log('**paso.....', paso)
        //console.log('**paso.length.....', paso.length)
        let posC = paso.indexOf('_');
        //console.log('**posC.....', posC)
        let propuestaId = paso.substr( 0, posC );
        let catalogoId = paso.substr(posC+1, paso.length-posC-1 );
        //console.log('*****propuestaId.....', propuestaId)
        //console.log('*****catalogoId.....', catalogoId)
        catOrigenesFront.map((o:any) => {
            if (o.id == catalogoId)
                o.specification = e.target.value
        }); 
        setIsChecked(!isChecked); //lo uso de puente para que recargue el front y se lleve el dato
        setSwBotonGuardar(true); //habilitar boton guardar en front
        setSwBotonEnviar(false); // hasta que grabe envia
        //console.log('.......catOrigenesFront...',catOrigenesFront)
        };

        const armaCatProcesos = (e:any) => {
        // console.log('e.target.id::', e.target.id);
        //let miCheckId = "0123456789_123_5"; 
        let miCheckId = e.target.id; 
        //console.log('miCheckId.....', miCheckId)
        let posP = miCheckId.indexOf('_');
        //console.log('**posP.....', posP)
        let paso = miCheckId.substr( posP+1, miCheckId.length-posP );
        //console.log('**paso.....', paso)
        //console.log('**paso.length.....', paso.length)
        let posC = paso.indexOf('_');
        //console.log('**posC.....', posC)
        let propuestaId = paso.substr( 0, posC );
        let catalogoId = paso.substr(posC+1, paso.length-posC-1 );
        //console.log('**propuestaId.....', propuestaId)
        //console.log('**catalogoId.....', catalogoId)
        catProcesosFront.map((p:any) => {
            if (p.id == catalogoId)
                p.activo = !p.activo
        }); 
        setIsChecked(!isChecked); // lo uso para que restarure la página y tome mis cambios
        setSwBotonGuardar(true);//habilitar boton guardar en front
        setSwBotonEnviar(false); // hasta que grabe envia
        //console.log('.......catProcesosFront...',catProcesosFront); 
        }

        //rutinas para filtrar los procesos
        const [busqueda, setBusqueda] = useState("");
        const [catProcesosFiltro, setCatProcesosFiltro] = useState([]);
        const handleChange=(e:any)=>{
            setBusqueda(e.target.value);
            console.log("busqueda: "+e.target.value);
            filtrar(e.target.value);
        }
        const filtrar = (terminoBusqueda:any) =>{
            //filtrado por acronimo, frecuencia y nombre
            console.log("catProcesosFront.......++++",catProcesosFront);
            var resultadosBusqueda=catProcesosFront.filter((elemento:any) =>{
                if (elemento.acronym.toString().toLowerCase().includes(terminoBusqueda.toLowerCase()) 
                || elemento.frequencyname.toString().toLowerCase().includes(terminoBusqueda.toLowerCase())
                || elemento.processname.toString().toLowerCase().includes(terminoBusqueda.toLowerCase()
                ) 
                ){
                return elemento;
                }
            })
            
            setCatProcesosFiltro(resultadosBusqueda);
        }
        const limpiarInputBuscador = () => {  
            setCatProcesosFiltro([]);
            //const cajaInput:any = document.getElementById("inputBusquedaTexto") as HTMLInputElement | null; 
            //const cajaInput:any = document.getElementById(inputBusquedaTexto); 
            var cajaInput:any = document.getElementById("inputLDAP") as HTMLInputElement | null; 
            if (cajaInput)  cajaInput.value= ""; 
            setBusqueda("")
            recargaPropuestaContenido();
        }
    
    //*vista
        return (
        <>
            {/* propuesta nueva - Encabezado: Agrega propuesta de cambio & fecha: hoy, folio:NEW, status:No enviado */}
                { props.propuestaNva &&
                    (<>
                        <div className="margin-left-03r">
                            <Row className="margin-left-1r margin-right-1r margin-bottom-1r">
                                <Col sm={11}>
                                    <h4>{eti.botones[0].text}</h4>
                                    {/* fecha */}
                                    <span id="fechah1" className="small">
                                        <BsCalendarEvent size="12px" color="#707070" /> {propuestaDetallesFront.fecha}
                                    </span> &nbsp;
                                    
                                    {/* folio */} 
                                    <span id="folioh1" className="color-azul3 small"> Folio: {propuestaDetallesFront.folio} </span>&nbsp;
                                    
                                    {/* estatus */}
                                    <span id="panelDes1">
                                        <BsEnvelope size="14px" color="#fd7e14" />
                                    </span>
                                    <span id="estatush"> {propuestaDetallesFront.estatusTexto}</span> {/*naranja*/}
                                </Col>

                                <Col sm={1} className="textAlignRight h3 color-Gris6" 
                                    onClick={botonCerrar} > {/* props.botonCierraPropuestaNva */}
                                    <i className="mdi mdi-chevron-down "></i>
                                </Col>  
                            </Row>
                        </div> 
                    </>)
                }
            
            {/* propuesta existente - contenido */}
                <div className='container'>
                    <div className="jumbotron">
                        <div className="padding-1r">
                                
                            {/* Descripción del cambio */}
                            <div>
                                <p className="mt-3 mb-3">{eti.contenido[0].text} &nbsp;
                                    <span className="color-azul3">
                                        <button data-tip data-for="articulo8-18">  {eti.contenido[0].text2}  </button>
                                        <ReactTooltip id="articulo8-18" type="info"  place="right" multiline >
                                            {articulos.articles[8].ch} <br/><br/>
                                            Articulo: 8<br /> {articulos.articles[8].description}<br/><br/>
                                            Articulo: 18<br />{articulos.articles[18].description}<br/>
                                        </ReactTooltip>
                                    </span> 
                                </p>
                                <textarea 
                                    id={`descCambio_${props.idPropuesta}`}  
                                    className="textareaPropuesta" 
                                    onChange={ armaDesCambio } 
                                    value={ desCambioFront }
                                    disabled={propuestaDetallesFront.sent ? true : false} 
                                >
                                </textarea>  
                            </div>  
                            
                            {/* Origen del cambio */}
                            <div>
                                <p className="mt-3 mb-3"> {eti.contenido[1].text} &nbsp;
                                    <span className="color-azul3">
                                        <button data-tip data-for="articulo8-18b"> {eti.contenido[0].text2} </button>
                                        <ReactTooltip id="articulo8-18b" type="info"  place="right" multiline >
                                        {articulos.articles[8].ch} <br/><br/>
                                            Articulo: 8<br /> {articulos.articles[8].description}<br/><br/>
                                            Articulo: 18<br />{articulos.articles[18].description}<br/>
                                        </ReactTooltip>
                                    </span>
                                </p>
                                <div className={propuestaDetallesFront.sent ? 'divCatalogoDisabled' :'divCatalogo'}  >
                                { catOrigenesFront?.map((catO:any, index:any) => (   /* propuestaDetallesFront.miCatOrigenes */
                                    x1=`catO-div1_${props.idPropuesta}_${catO.id}`,  
                                    x2=`catO-div2_${props.idPropuesta}_${catO.id}`,  
                                    x3=`catO-input_${props.idPropuesta}_${catO.id}`,  
                                    x4=`catO-div3_${props.idPropuesta}_${catO.id}`,  
                                    x5=`catO-div4_${props.idPropuesta}_${catO.id}`,  
                                    x6=`catO-Especifica_${props.idPropuesta}_${catO.id}`, 
                                    
                                    <>
                                    <div id={x1} >   {/* className={catO.visible ? 'display-block' :'display-none'} */}
                                        <div id={x2} className="claseCK">
                                            <input
                                                type="checkbox"
                                                key={x3}
                                                id={x3} name={x3}
                                                checked={catO.activo}
                                                onChange={armaCatOrigenes}
                                                disabled={catO.disabled}
                                                //disabled={propuestaDetallesFront.sent ? true : false}
                                            />
                                        </div>
                                        <div id={x4} className="claseCKTexto padding-07r noBR">
                                            {" "}
                                            {catO.name} 
                                        </div>
                                        <div id={x5} className={catO.activo ? 'display-block':'display-none'} >
                                            <textarea 
                                                id={x6} 
                                                className="textareaPropuesta margin-1r width-95"
                                                placeholder= {catO.description}
                                                value={catO.specification}
                                                onChange={armaCatOrigenesEspecifica}
                                                disabled={propuestaDetallesFront.sent ? true : false} >
                                            </textarea>  
                                        </div> 
                                    </div>
                                    </>     
                                ))}
                                </div>
                            </div>  

                            {/* Procesos que potencialmente serán modificados */}
                            <div>

                                {/* párrafo: Procesos que potencialmente serán modificados */}
                                <p className="mt-3 ">{eti.contenido[2].text} &nbsp;
                                    <span className="color-azul3">
                                        <button data-tip data-for="articulo8-18c"> {eti.contenido[0].text2} </button>
                                        <ReactTooltip id="articulo8-18c" type="info"  place="right" multiline >
                                            {articulos.articles[8].ch} <br/><br/>
                                            Articulo: 8<br /> {articulos.articles[8].description}<br/><br />
                                            Articulo: 18<br />{articulos.articles[18].description}<br/>
                                        </ReactTooltip>
                                    </span>
                                </p>

                                {/* título: Lista de Procesos:  input: Búsqueda:  */}
                                {propuestaDetallesFront.sent == false && (
                                    <p className="mb-3">
                                        <span className="color-Gris1 noBR">
                                            {eti.contenido[3].text} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            {eti.contenido[4].text} &nbsp;
                                            <input
                                                type="text"
                                                id="inputBusquedaTexto"
                                                name="inputBusquedaTexto"
                                                className="inputBusqueda"
                                                placeholder={eti.etiquetas[9].text}
                                                style={{ display: "inline" }}
                                                value={busqueda}
                                                onChange={handleChange}
                                            />
                                        </span>
                                        <span style={{marginLeft:"-20px"}}className="color-azul7 cursorHand" onClick={limpiarInputBuscador} >x</span>
                                    </p>
                                )}

                                {/* chekcbox's de lista de Procesos */}
                                <div className={ propuestaDetallesFront.sent ? "divCatalogoDisabled" : "divCatalogo divCatProcesos" } >
                                  {catProcesosFiltro.length>0 
                                    ? (<>
                                        {catProcesosFiltro?.map(( catP: any, index: any) => (
                                            (x1 = `catPF-div1_${props.idPropuesta}_${catP.id}`),
                                            (x2 = `catPF-div2_${props.idPropuesta}_${catP.id}`),
                                            (x3 = `catPF-input_${props.idPropuesta}_${catP.id}`),
                                            (x4 = `catPF-div3_${props.idPropuesta}_${catP.id}`),
                                            (<>
                                                <div id={x1}>
                                                    {" "}
                                                    {/* className={catP.visible ? 'display-block' :'display-none'} */}
                                                    <div id={x2} className={(catP.ordena== 1 ) ? "padding-07r background-color-azul9" : "padding-07r"} title={catP.title} >
                                                        <div className="claseCK" >
                                                            <input
                                                                type="checkbox"
                                                                key={x3}
                                                                id={x3}
                                                                name={x3}
                                                                checked={catP.activo}
                                                                onChange={armaCatProcesos}
                                                                disabled={catP.disabled}
                                                            />
                                                        </div>
                                                        <div id={x4} className="claseCKTexto padding-07r noBR" >
                                                            {/*acrónimo */}
                                                            <span className="color-azul3">  {catP.acronym} -  </span>
                                                            {/*programa*/}
                                                            <span className=""> {catP.processname} &nbsp; / &nbsp;  </span>
                                                            {/*frecuencia */}
                                                            <span className="color-azul2"> {catP.frequencyname} &nbsp;&nbsp; </span>
                                                            {/*estatus */}
                                                            <span className={catP.clasexEstatusIcono}> {catP.estatusProceso} </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>) 
                                        )) }
                                      </>)
                                    : (<>
                                        {catProcesosFront?.map(( catP: any, index: any ) => (
                                            (x1 = `catP-div1_${props.idPropuesta}_${catP.id}`),
                                            (x2 = `catP-div2_${props.idPropuesta}_${catP.id}`),
                                            (x3 = `catP-input_${props.idPropuesta}_${catP.id}`),
                                            (x4 = `catP-div3_${props.idPropuesta}_${catP.id}`),
                                            ( <>
                                                <div id={x1}>
                                                    {" "}
                                                    {/* className={catP.visible ? 'display-block' :'display-none'} */}
                                                    {/* { (catP.ordena== 1 ) ? "claseCK background-color-azul9" : "claseCK" } */}
                                                    {/* <div id={x2}  className={catP.clasexEstatus} title={catP.title} > */}
                                                    <div id={x2} className={(catP.ordena== 1 ) ? "padding-07r background-color-azul9" : "padding-07r"}  title={catP.title} >
                                                        <div className="claseCK">
                                                            <input
                                                                type="checkbox"
                                                                key={x3}
                                                                id={x3}
                                                                name={x3}
                                                                checked={catP.activo}
                                                                onChange={armaCatProcesos}
                                                                disabled={catP.disabled}
                                                            />
                                                        </div>
                                                        <div  id={x4} className="claseCKTexto padding-07r noBR" >
                                                            {/*acronimo */}
                                                            <span className="color-azul3"> {catP.acronym} - </span>
                                                            {/*programa */}
                                                            <span className=""> {catP.processname} &nbsp; / &nbsp; </span>
                                                            {/*frecuencia */}
                                                            <span className="color-azul2"> {catP.frequencyname} &nbsp;&nbsp; </span>
                                                            {/*estatus */}
                                                            <span className={catP.clasexEstatusIcono}> {catP.estatusProceso} </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>)
                                        )) }
                                      </>)
                                  }
                                </div>
                            </div>  

                            {/* Botones */}
                            <div className="text-right padding-2r">
                                { propuestaDetallesFront.sent == false && 
                                  (<>
                                    { swBotonGuardar  /* propuestaDetallesFront.btnGuardar  */
                                        ? (<> <button onClick={botonGuardar} className="btn btn-activo">  <span dangerouslySetInnerHTML={{ __html: etiGlobal[2].text, }} ></span></button>&nbsp;</> )
                                        : (<> <button onClick={botonGuardar} className="btn btn-inactivo" disabled>  <span dangerouslySetInnerHTML={{ __html: etiGlobal[2].text, }} ></span> </button>&nbsp;</> )
                                    }
                                    { swBotonEnviar /* propuestaDetallesFront.btnEnviar  */
                                        ? (<> <button onClick={botonEnviar} className="btn btn-activo"> <span dangerouslySetInnerHTML={{ __html: etiGlobal[3].text, }} ></span> </button>&nbsp;</> )
                                        : (<> <button onClick={botonEnviar} className="btn btn-inactivo" disabled> <span dangerouslySetInnerHTML={{ __html: etiGlobal[3].text, }} ></span> </button>&nbsp;</> )
                                    }
                                    { swBotonEliminar /* propuestaDetallesFront.btnEliminar  */
                                        && (<> <button onClick={botonEliminar} className="btn btn-activoRojo"> <span dangerouslySetInnerHTML={{ __html: etiGlobal[4].text, }} ></span> </button>&nbsp;</> )
                                    }
                                  </>)
                                } 
                                <button onClick={botonCerrar}  className="btn btn-sinColor"> <span dangerouslySetInnerHTML={{ __html: etiGlobal[1].text, }} ></span> </button>&nbsp;
                            </div>

                        </div> 
                    </div>
                </div>

            {/* ventana de carga con spin que se abre mientras lee el api */}
                { cargandoSpin && <CargandoSpin /> }

        </>
        );
    }


/* switch(responseAPI.status){
    case 404:  paso.desresul= "El usuario no existe"; break;
    case 401:  paso.desresul= "No autorizado"; break;
    case 404:  paso.desresul= "No tiene información"; break;
    default: paso.desresul= responseAPI.statusText; break;
    } */

/* className={propuestaDetallesFront.sent ? 'divCatalogoDisabled' :'divCatalogo'} */